/**
 * Promisified версия setTimeout'а для удобного вызова.
 *
 * @example
 * await sleep(1000);
 */
export const sleep = (ms: number) => new Promise(r => setTimeout(r, ms));
